export default __webpack_public_path__ + "static/media/icon_sort.cb7c0b87.svg";